import { render } from "./ToPageTop.vue?vue&type=template&id=faa024fa&scoped=true&ts=true"
import script from "./ToPageTop.vue?vue&type=script&lang=ts"
export * from "./ToPageTop.vue?vue&type=script&lang=ts"

import "./ToPageTop.vue?vue&type=style&index=0&id=faa024fa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa024fa"]])

export default __exports__